var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "section-head" }, [_vm._v("签到规则配置")]),
    _c(
      "div",
      { staticClass: "rule-block" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 24 } },
          [
            _c(
              "el-col",
              { attrs: { span: 10 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "签到方式", prop: "signInRule.method" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "220px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.signInRule.method,
                          callback: function ($$v) {
                            _vm.$set(_vm.signInRule, "method", $$v)
                          },
                          expression: "signInRule.method",
                        },
                      },
                      _vm._l(_setup.methodOptions, function (opt) {
                        return _c("el-option", {
                          key: opt.value,
                          attrs: { label: opt.label, value: opt.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "活动天数", prop: "signInRule.cycle_days" },
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "220px" },
                      attrs: { min: 1, max: 7, precision: 0, controls: false },
                      model: {
                        value: _vm.signInRule.cycle_days,
                        callback: function ($$v) {
                          _vm.$set(_vm.signInRule, "cycle_days", $$v)
                        },
                        expression: "signInRule.cycle_days",
                      },
                    }),
                    _c("span", { staticClass: "cycle-days-tip" }, [
                      _vm._v("活动天数最多7天"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }